import { IErrorHandler } from '../services/ErrorHandler/IErrorHandler';
import { CognitoHttpClient } from '../services/HttpClient/CognitoHttpClient';
import { UmmyHttpClient } from '../services/HttpClient/UmmyHttpClient';
import {
  IStorageProvider,
  StorageKeys,
} from '../services/StorageProvider/IStorageProvider';
import { AuthorizationApi } from './authorization/AuthorizationApi';
import { IAuthorizationApi } from './authorization/IAuthorizationApi';
import { CompanyApi } from './company/CompanyApi';
import { ICompanyApi } from './company/ICompanyApi';
import { FeedbackApi } from './feedback/FeedbackApi';
import { IFeedbackApi } from './feedback/IFeedbackApi';
import { GamificationApi } from './gamification/GamificationApi';
import { IGamificationApi } from './gamification/IGamificationApi';
import { ITeamApi } from './team/ITeamApi';
import { TeamApi } from './team/TeamApi';
import { IUserApi } from './user/IUserApi';
import { UserApi } from './user/UserApi';
import { HarmoniaApi } from './harmonia/HarmoniaApi';
import { SlackApi } from './slack/SlackApi';
import { IHarmoniaApi } from './harmonia/IHarmoniaApi';
import { ISlackApi } from './slack/ISlackApi';
import { ISurveyApi } from './survey/ISurveyApi';
import { SurveyApi } from './survey/SurveyApi';

export type CreateApiParams = {
  baseUrl: string;
  errorHandler: IErrorHandler;
  storageProvider: IStorageProvider;
};

export const createApi = async ({
  baseUrl,
  errorHandler,
  storageProvider,
}: CreateApiParams) => {
  const accessToken: string | null = await storageProvider.getItem(
    StorageKeys.ACCESS_TOKEN_KEY
  );
  const refreshToken: string | null = await storageProvider.getItem(
    StorageKeys.REFRESH_TOKEN_KEY
  );

  const ummyHttpClient = new UmmyHttpClient({
    baseUrl,
    errorHandler,
    accessToken,
    refreshToken,
  });

  const cognitoHttpClient = new CognitoHttpClient({
    errorHandler,
  });

  const authorizationApi: IAuthorizationApi = new AuthorizationApi(
    cognitoHttpClient,
    ummyHttpClient,
    storageProvider
  );

  const feedbackApi: IFeedbackApi = new FeedbackApi(ummyHttpClient);
  const userApi: IUserApi = new UserApi(ummyHttpClient);
  const teamApi: ITeamApi = new TeamApi(ummyHttpClient);
  const companyApi: ICompanyApi = new CompanyApi(ummyHttpClient);
  const gamificationApi: IGamificationApi = new GamificationApi(ummyHttpClient);
  const harmoniaApi: IHarmoniaApi = new HarmoniaApi(ummyHttpClient);
  const slackApi: ISlackApi = new SlackApi(ummyHttpClient);
  const surveyApi: ISurveyApi = new SurveyApi(ummyHttpClient);

  return {
    authorization: authorizationApi,
    userApi,
    teamApi,
    companyApi,
    feedbackApi,
    gamificationApi,
    harmoniaApi,
    slackApi,
    surveyApi,
  };
};
